<template>
	<div v-loading="loading" class="main-content">
		<div v-if="!loading" class="main-content-inner">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-12 content-margin">
						<div class="content">
							<div class="content-header">
								<h2>
									Price
								</h2>
							</div>
							<div class="content-body">
								<el-form @submit.prevent.native="handleSubmit('form')" :model="form" :rules="rules" ref="form">
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item label="Price" prop="price">
												<el-input type="text" v-model.number="form.price" placeholder="Please enter price"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 col-md-12">
											<el-form-item>
												<el-button native-type="submit" type="primary" plain>Save</el-button>
											</el-form-item>
										</div>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'

export default {
	name: 'Price',
	metaInfo () {
		return {
			title: 'Price',
		}
	},
	data () {
        return {
			loading: true,
			form: {
				price: null
			},
			rules: {
				price: [
					{ required: true, message: 'This field cannot be empty', trigger: 'blur' },
				]
			}
        }
    },
	mounted () {
		this.loadSettings()
	},
	methods: {
		loadSettings () {
			return HTTP({
				method: 'GET',
				url: '/settings',
				crossdomain: true
			})
			.then(response => {
				this.form.price = response.data.price
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleSubmit (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true
					return HTTP({
						method: 'PUT',
						url: '/settings',
						crossdomain: true,
						data: this.form
					})
					.then(() => {
						this.loading = false
						this.$notify({
							title: 'Success',
							message: 'Price has been updated',
							type: 'success',
							position: 'bottom-right',
							duration: 2500
						})
					})
					.catch(error => {
						this.loading = false
						this.$notify({
							title: 'Error',
							message: error.response.data.message ? error.response.data.message : 'An error occured, please try later',
							type: 'error',
							position: 'bottom-right',
							duration: 3500
						})
					})
				} else {
					return false
				}
			})
		}
	}
}
</script>
